/* תוכן עמוד הבית.
   הטקסטים משקפים את הגרסה החיה — כלומר גוף ה-HTML המקורי לאחר החלת
   העריכות שהיו ב-texts.json. הודעת "האתר בבנייה" הוסרה לפי החלטה. */

export const HOME_HERO = {
  logoAlt: 'סינרו — מעטפת אסטרטגית מלאה',
  tagline: 'הכלים המקצועיים לצמיחה עסקית - הכל תחת קורת גג אחת, במיוחד בשבילך.',
} as const;

export const HOME_WHO = {
  kicker: 'מי אנחנו',
  titleLead: 'מעטפת',
  titleThin: 'אסטרטגית מלאה.',
  lead: 'כל הכלים והמומחים לצמיחה עסקית תחת קורת גג אחת.',
  paragraphs: [
    'צמיחה עסקית אמיתית ופריצת דרך אמיתית קורות כשיש לך את האנשים הנכונים לצידך.',
    'עסק שרוצה לגדול צריך ארגז כלים רחב ומקצועי בכל חזית: מאסטרטגיה עסקית, פיתוח ומימון, דרך טכנולוגיה ואוטומציות מתקדמות, ועד שיווק חד וקשרי ממשל.',
  ],
  /* פסקה עם הדגשה בסופה — ההדגשה מופרדת לשדה נפרד כדי להימנע מ-HTML גולמי */
  highlightIntro:
    'במקום לפזר אנרגיה בין גורמים שונים, סינרו מרכזת עבורך את מיטב אנשי המקצוע והמובילים בתחומם מתוך המגזר עצמו- ',
  highlightStrong: 'הכל תחת קורת גג אחת בסינרגיה מושלמת.',
  closing:
    'אנחנו כאן כדי לתת לך את המעטפת, המומחיות והכלים המדויקים ביותר, שמשתלבים בעסק שלך ומעניקים לך את הגב האיתן לנהל, להוביל ולהגיע בדיוק לתוצאות שאתה שואף אליהן.',
} as const;

export const HOME_NUMBERS = [
  { value: '8', label: 'מחלקות מקצועיות תחת קורת גג אחת' },
  { value: '360', suffix: '°', label: 'פתרון הוליסטי מקצה לקצה' },
  { value: '1', label: 'גב אחד — כל המומחים' },
  { value: '∞', label: 'אפשרויות צמיחה' },
] as const;

export const HOME_PROCESS = {
  kicker: 'תהליך לקוח-',
  titleLead: 'המסלול',
  titleThin: 'שמוביל להצלחה.',
  lead: 'שישה שלבים — מהיכרות ועד עצמאות עסקית מלאה.',
  railStart: 'התחלה',
  railEnd: 'סיום',
} as const;

/* שלבי התהליך. הכותרת מפוצלת לשתי שורות כפי שמוצג במקור. */
export const PROCESS_STEPS = [
  {
    icon: 'discover',
    titleLines: ['אבחון עסקי', 'מקיף'],
    description: 'מכירים אתכם, מבינים את העסק — אבחון, ניתוח תהליכים והגדרת יעדים.',
  },
  {
    icon: 'team',
    titleLines: ['הצמדת הצוות', 'המושלם'],
    description: 'יועץ עסקי ופרויקטור קבוע שמלווים אתכם לאורך כל הדרך.',
  },
  {
    icon: 'map',
    titleLines: ['מיפוי אסטרטגי', 'מעמיק'],
    description: 'ניתוח שוק, זיהוי הזדמנויות והבנת התחרות — תובנות מבוססות.',
  },
  {
    icon: 'target',
    titleLines: ['בניית אסטרטגיה', 'ויעדים'],
    description: 'תוכנית פעולה עם מטרות ברורות, אבני דרך ומדדי הצלחה.',
  },
  {
    icon: 'gears',
    titleLines: ['יישום וניהול', 'שוטף'],
    description: 'ליווי שלב אחר שלב, פתרון בעיות בזמן אמת והתקדמות לפי התוכנית.',
  },
  {
    icon: 'graduate',
    titleLines: ['העברת ידע', 'ועצמאות'],
    description: 'הכלים, הידע והביטחון להמשיך לבד — לנהל, לצמוח ולהתמודד.',
  },
] as const;

export const HOME_DEPARTMENTS = {
  kicker: '8 מחלקות',
  titleLead: 'הליבה',
  titleThin: 'המקצועית...',
  lead: 'לחצו על כל מחלקה כדי לגלות את תחומי האחריות והמומחיות שלה.',
} as const;

export const HOME_ABOUT = {
  kicker: 'אודות-',
  titleLead: 'מאחורי',
  titleSecond: 'השותפות',
  titleThin: '.',
  paragraphs: [
    'ברוכים הבאים לסינרו. השם שלנו מגיע ממילה אחת שמניעה הכל: ',
  ],
  strongWord: 'סינרגיה.',
  afterStrong:
    'הבנו שעסק שרוצה לצמוח ולפרוץ קדימה באמת, לא יכול להסתמך על ספקים מפוזרים, אלא חייב מעטפת אחת שבה כל החלקים עובדים בסנכרון מוחלט.',
  departmentsIntro: 'כדי לתת לך את הגב הזה, ריכזנו תחת קורת גג אחת 8 מחלקות מקצועיות:',
  departmentsBody:
    'יזמות, שיווק, מימון, משאבי אנוש, טכנולוגיה ועוד. המחלקות שלנו עובדות בתיאום הדוק עם האסטרטג שלך, ומספקות את כל התמיכה האופרטיבית, המשאבים והביצוע המדויק בשטח.',
  values:
    'התוצאה היא מערכת מקצועית אחת שמתקתקת בשבילך, ממקסמת רווחים ומזרימה שפע וביטחון כלכלי לעסק ולך. מתוך נאמנות מוחלטת לערכים שסינרו מושתתת עליהם: יושרה | יוזמה | חדשנות | מצוינות | אחריות.',
  ctaLines: [
    'רוצים להכיר לעומק את האנשים שמאחורי השותפות,',
    'לגלות את החזון שלנו ולשמוע מה אומרים העסקים שכבר גדלים איתנו?',
  ],
  ctaLabel: 'כנסו לעמוד האודות ←',
} as const;
